var Backbone = require('backbone');

var Base = require('front/components/Base/Base');

require('./Nav.less');

module.exports = Base.extend({
    el: '.Nav',

    initialize: function () {
        app.vent.on('activateIndex', this.activateIndex.bind(this));
        app.vent.on('deactivateIndex', this.deactivateIndex.bind(this));
    },

    activateIndex: function () {
        this.$el.addClass('Nav--isIndex');
    },

    deactivateIndex: function () {
        this.$el.removeClass('Nav--isIndex');
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Nav/Nav.js
// module id = 37
// module chunks = 0